import { RoundSolidButton } from '@avtkit/controls/Button';
import styled from 'styled-components';
import i18n from '../../services/i18n';

export default styled(RoundSolidButton).attrs({
   size: 'medium',
   type: 'tertiary',
   children: i18n.t('Activate'),
})``;
